import { useContext, useEffect } from "react";
import { StoryContext } from "../context/StoryContext";

const Bookmarks = () => {
  const { bookmarks, getBookmarks } =
    useContext(StoryContext);

  useEffect(() => {
    getBookmarks();
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h1>Bookmarks</h1>

      {bookmarks.map((story) => (
        <div key={story._id}>
          <h2>{story.title}</h2>
        </div>
      ))}
    </div>
  );
};

export default Bookmarks;